var map = {
	"./black/duijiang2.png": "8g/U",
	"./blue/duijiang2.png": "/CRJ",
	"./white/duijiang2.png": "flhb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nNI9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/duijiang2\.png$
// module id = nNI9
// module chunks = 24